export const HOME_ADDRESS = 'HOME_ADDRESS'
export const HOME_PURCHASE_DATE = 'HOME_PURCHASE_DATE'
export const HOME_CREATE = 'HOME_CREATE'

export const STEPS = {
  HOME_ADDRESS,
  HOME_PURCHASE_DATE,
  HOME_CREATE
}
